export const defaultComponentes = () => {
    return {
        id_producto: '',
        nocas: '',
        componente: '',
        porcentaje: '',
    }
}

export const defaultSustancias = () => {
    return {
        id_tab: '',
        id_componente: '',
        nocas: '',
        sustancia: '',
        tipo: '',
        porcentaje: '',
    }
}

export const defaultCas = () => {
        return {
            id_tab: '',
            id_producto: '',
            id_componente: '',
            nocas: '',
            componente: '',
            sustancia: '',
            tipo: '',
            porcentaje: '',
        }
    }
    //
export const defaultBiopersistentes = () => {
    return {
        sustancia_quimica: '',
        nocas: '',
        clasificacion_sga: '',
        bioacumulable: 0,
        biopersistente: 0,
        peligro_corto_plazo_ambiente: 0,
        efecto: '',
        complemento: '',
        biopersistenteMasivo: ''
    }
}
export const defaultIarc = () => {
    return {
        nocas: '',
        sustancia_quimica: '',
        grupo: '',
        anio: '',
    }
}
export const defaultMutagenicos = () => {
    return {
        sustancia_quimica: '',
        nocas: '',
        efecto: '',
        complemento: '',
        clasificacion_sga: '',
        mutagenicoMasivo: ''
    }
}
export const defaultNeurotoxicos = () => {
    return {
        nocas: '',
        sustancia_quimica: '',
        efecto: '',
        neurotoxicidad: '',
        complemento: '',
        reglamento: '',
    }
}
export const defaultOtotoxicos = () => {
    return {
        sustancia_quimica: '',
        nocas: '',
        familiacompuestos: '',
        afeccionsobre: '',
    }
}
export const defaultReprotoxicos = () => {
    return {
        sustancia_quimica: '',
        nocas: '',
        efecto: '',
        complemento: '',
        reprotoxicoMasivo: ''
    }
}
export const defaultSustanciasControladas = () => {
    return {
        nocas: '',
        sustancia_quimica: '',
        cantidad: '',
        territorialidad: '',
    }
}
export const defaultTeratogenicos = () => {
    return {
        sustancia_quimica: '',
        nocas: '',
        efecto: '',
        complemento: '',
        teratogenicoMasivo: ''
    }
}
export const defaultTlv = () => {
    return {
        nocas: '',
        sustancia_quimica: '',
        acgihstel: '',
        acgihtwa: '',
        anotaciones: '',
        acgihbei: '',
        basis: '',
        mw: '',
        anio: '',
    }
}

export default {
    biopersistentes: [],
    iarcs: [],
    mutagenicos: [],
    neurotoxicos: [],
    ototoxicos: [],
    reprotoxicos: [],
    sustanciasControladas: [],
    teratogenicos: [],
    tlvs: [],
    cas: [],
    compo: [],
    arrayComponentes: [],
    arraysustancias: [],
    arrayCas: [],
    casCompo: [],
    componeCas: [],
    componentes: [],
    sustancias: [],
    compoEditado: {},

    selectedComponente: defaultComponentes(),
    selectedSustancia: defaultSustancias(),
    selectedCas: defaultCas(),
    selectedBiopersistente: defaultBiopersistentes(),
    selectedIarc: defaultIarc(),
    selectedMutagenico: defaultMutagenicos(),
    selectedNeurotoxico: defaultNeurotoxicos(),
    selectedOtotoxico: defaultOtotoxicos(),
    selectedReprotoxico: defaultReprotoxicos(),
    selectedSustanciaControlada: defaultSustanciasControladas(),
    selectedTeratogenico: defaultTeratogenicos(),
    selectedTlv: defaultTlv(),
    errorCas: false,
    error: false,
    verTarjeta: false,
    accion: 'crear',

    filtro: {
        nocas: '',
        id_componente: ''
    },
    params_caslistar: {
        buscar: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    params_nocas: {
        buscar: '',
        id_producto: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'Asc',
    },
    params_tlv: {
        buscar: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    },

    params_iarc: {
        buscar: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    params_neuro: {
        buscar: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    params_ototo: {
        buscar: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    params_repro: {
        buscar: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    params_terato: {
        buscar: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    params_muta: {
        buscar: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    params_bio: {
        buscar: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    params_sustancia: {
        buscar: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
}
